module.exports = __webpack_public_path__ + "static/media/home_landscape.371b7639.png";